import { BtText } from '@linqpal/components/src/ui'
import React from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import {
  AttachmentIconBlue,
  IconArrowRightBlue,
} from '../../../../../assets/icons'
import { paths } from '../../../../links'
import { useTranslation } from 'react-i18next'
import { EInvoiceType } from '@linqpal/models'

interface IViewInvoiceAttachmentProps {
  invoice: any
  navigation: any
}

export const ViewInvoiceAttachment: React.FC<IViewInvoiceAttachmentProps> = ({
  invoice,
  navigation,
}) => {
  const onInvoiceDocClick = () => {
    navigation.navigate(paths.Console.Payables.AttachmentPreview, {
      id: invoice._id,
    })
  }
  const { t } = useTranslation('global')

  return (
    <TouchableOpacity style={styles.container} onPress={onInvoiceDocClick}>
      <View style={styles.attachmentIconContainer}>
        <AttachmentIconBlue height={16} width={16} />
      </View>
      <BtText style={styles.text}>
        {invoice.type === EInvoiceType.QUOTE
          ? t('InvoiceDetails.view-quote-attachment')
          : t('InvoiceDetails.view-invoice-attachment')}
      </BtText>
      <IconArrowRightBlue width={16} height={16} />
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 120,
  },
  attachmentIconContainer: {
    marginBottom: 1,
  },
  text: {
    fontSize: 12,
    lineHeight: 24,
    color: '#00A0F3',
    fontFamily: 'Inter',
    fontWeight: '700',
    letterSpacing: 0,
    marginRight: 4,
  },
})
